import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id       : 'menu',
        title    : 'MENU',
        translate: 'MENU',
        type     : 'group',
        children : [
            {
                id       : 'raw-data',
                title    : 'Responses',
                type     : 'item',
                icon     : 'assignment',
                url      : '/dashboard/raw-data',
            },
            {
                id       : 'responses',
                title    : 'Raw Data',
                type     : 'item',
                icon     : 'list_alt',
                url      : '/dashboard/all-responses'
            },
            {
                id       : 'counties',
                title    : 'Counties',
                type     : 'item',
                icon     : 'language',
                url      : '/counties',
                bpType   : ['Admin'],
            },
            // TODO: Bring back if requested
            // {
            //     id       : 'livelihoodzones',
            //     title    : 'Livelihoodzones',
            //     type     : 'item',
            //     icon     : 'assessment',
            //     url      : '/livelihoodzones',
            //     bpType   : ['Admin'],
            // },
            {
                id       : 'sub-locations',
                title    : 'Sub-Locations',
                type     : 'item',
                icon     : 'language',
                url      : '/sub-locations',
                bpType   : ['Admin'],
            },
            {
                id       : 'users',
                title    : 'Users',
                type     : 'item',
                icon     : 'people',
                url      : '/users',
                bpType   : ['Admin'],
            },
            {
                id       : 'wg-reports',
                title    : 'Zone Level Reports',
                type     : 'item',
                icon     : 'file_copy',
                url      : '/reports/zone-level',
                bpType   : ['Admin'],
            },
            {
                id       : 'wg-reports',
                title    : 'Wealth Group Reports',
                type     : 'item',
                icon     : 'file_copy',
                url      : '/reports/wealth-group',
                bpType   : ['Admin'],
            },
            // {
            //     id       : 'maps-reports',
            //     title    : 'Maps Reports',
            //     type     : 'item',
            //     icon     : 'map',
            //     url      : '/reports/maps-reports',
            //     bpType   : ['Admin'],
            // },
            {
                id       : 'dashboard',
                title    : 'LZ Map Reports',
                translate: 'NAV.SAMPLE.TITLE',
                type     : 'collapsable',
                icon     : 'dashboard',
                bpType   : ['Admin'],
                children: [
                    {
                        id   : 'map-wrapper',
                        title: 'All livelihoodzones',
                        type : 'item',
                        icon : '',
                        url  : '/reports/maps-reports'
                    },
                    {
                        id   : 'population',
                        title: 'Population distribution',
                        type : 'item',
                        icon : '',
                        url  : '/reports/wg-population-distribution-map-reports'
                    },
                    {
                        id   : 'water',
                        title: 'Water sources',
                        type : 'item',
                        icon : '',
                        url  : '/reports/zl-main-water-sources-map-reports'
                    },
                    
                    {
                        id   : 'hunger',
                        title: 'Hunger patterns',
                        type : 'item',
                        icon : '',
                        url  : '/reports/zl-hunger-patterns-map-reports'
                    },
                    {
                        id   : 'hazards',
                        title: 'Hazards',
                        type : 'item',
                        icon : '',
                        url  : '/reports/zl-hazards-map-reports'
                    },
                ]
            },
            {
                id       : 'dashboard',
                title    : 'WG Map Reports',
                translate: 'NAV.SAMPLE.TITLE',
                type     : 'collapsable',
                icon     : 'dashboard',
                bpType   : ['Admin'],
                children: [
                    // {
                    //     id   : 'map-wrapper',
                    //     title: 'Livelihoodzones',
                    //     type : 'item',
                    //     icon : '',
                    //     url  : '/reports/maps-reports'
                    // },
                    {
                        id   : 'ownership',
                        title: 'Livestock ownership',
                        type : 'item',
                        icon : '',
                        url  : '/reports/wg-map-reports'
                    },
                    {
                        id   : 'income-sources',
                        title: 'Income sources',
                        type : 'item',
                        icon : '',
                        url  : '/reports/income-sources-map-reports'
                    },
                    {
                        id   : 'migration-patterns',
                        title: 'Migration patterns',
                        type : 'item',
                        icon : '',
                        url  : '/reports/migration-patterns-map-reports'
                    },
                    {
                        id   : 'tlu',
                        title: 'TLU reports',
                        type : 'item',
                        icon : '',
                        url  : '/reports/tlc-map-reports'
                    },
                    {
                        id   : 'crop-contribution',
                        title: 'Crop contribution',
                        type : 'item',
                        icon : '',
                        url  : '/reports/crop-contribution-map-reports'
                    },
                ]
            },
        ]
    }
];
